import { ToolsRoutes } from '@/modules/typeform/routes/tools.routes';

export const router = [
  {
    path: `/${ToolsRoutes.DIAGNOSTIC_RESULT.path}/:formId/:id`,
    name: ToolsRoutes.DIAGNOSTIC_RESULT.name,
    component: () => import('/@/modules/typeform/components/stateful/DiagnosticResultsPage.vue'),
    meta: { authOnly: false }
  },
  {
    path: `/${ToolsRoutes.DIAGNOSTIC_TOOL.path}/:id`,
    name: ToolsRoutes.DIAGNOSTIC_TOOL.name,
    component: () => import('/@/modules/typeform/components/stateful/DiagnosticToolPage.vue'),
    meta: { authOnly: false }
  }
];
